/**
 * THE ONE PAGER (the pagination rule): every list says what it is showing of
 * how many, and offers the page before and after. The server caps a page at
 * 200 rows, so a list without this is a list that silently stops.
 */
import * as React from 'react';
import { Button } from './ui.js';

export interface PageInfo { number: number; size: number; total: number }

export function pagerLabel(p: PageInfo): string {
  if (p.total <= 0) return 'Nothing to show';
  const from = (p.number - 1) * p.size + 1;
  const to = Math.min(p.total, p.number * p.size);
  return `Showing ${from}–${to} of ${p.total}`;
}

export function Pager({ page, onPage }: { page: PageInfo; onPage: (n: number) => void }) {
  const last = Math.max(1, Math.ceil(page.total / page.size));
  return (
    <div className="totals" style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10 }}>
      <span className="muted">{pagerLabel(page)}</span>
      <Button small disabled={page.number <= 1} onClick={() => onPage(page.number - 1)}>Previous</Button>
      <Button small disabled={page.number >= last} onClick={() => onPage(page.number + 1)}>Next</Button>
    </div>
  );
}
